import { LiquorTreeOptions } from 'liquor-tree'
import { AssaysViewSampleNodeStructure } from '@/components/assays-view/components/modal/assays-view-modal.model'
import { CommonPriorityResponse } from '@/api/services/common/priority/common-priority.dto'

export interface BatchItemWrapper<T> {
    batchItem: T
    priority: CommonPriorityResponse

    expanded?: boolean
}

export interface AssaysViewBatchModalState<T = unknown> {
    loaded: boolean

    treeOptions: LiquorTreeOptions
    sampleNodes: AssaysViewSampleNodeStructure[]

    priorityGlobal: CommonPriorityResponse | null
    batchItemFilter: string
    batchItemLoading: boolean
    batchItemWrappers: BatchItemWrapper<T>[]
    selectedBatchItemWrappers: BatchItemWrapper<T>[]
}
export const initialAssaysViewBatchModalState =
    <T>(): AssaysViewBatchModalState<T> => ({
        loaded: false,

        treeOptions: {
            checkbox: true,
            autoCheckChildren: false
        },
        sampleNodes: [],

        priorityGlobal: null,
        batchItemFilter: '',
        batchItemLoading: false,
        batchItemWrappers: [],
        selectedBatchItemWrappers: []
    })
